/* eslint-disable react/no-did-mount-set-state */
import React from 'react';
import PropTypes from 'prop-types';
import { Jumbotron } from 'reactstrap';
import Loading from './Loading';
import Change from './Change';

class CoreMetric extends React.Component {
  render() {
    return (
      <Jumbotron className="text-center">
        {this.props.loading && <Loading />}
        {this.props.header}
        <p />
        <div style={{ visibility: this.props.loading ? 'hidden' : 'visible' }}>
          <h1>{this.props.body}</h1>
          <Change change={this.props.change} />
        </div>
      </Jumbotron>
    );
  }
}

CoreMetric.propTypes = {
  header: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  change: PropTypes.number,
  loading: PropTypes.bool,
};

CoreMetric.defaultProps = {
  change: 0,
  loading: false,
};

export default CoreMetric;



// WEBPACK FOOTER //
// ./src/components/core/CoreMetric.js